import { render, staticRenderFns } from "./FeatureList.vue?vue&type=template&id=d1d85300&"
import script from "./FeatureList.vue?vue&type=script&lang=js&"
export * from "./FeatureList.vue?vue&type=script&lang=js&"
import style0 from "./FeatureList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports